var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.72688 8.27247L5.72688 12.9111C5.72688 13.5022 6.2965 14 6.97291 14H7.02631C7.70273 14 8.27234 13.5022 8.27234 12.9111V8.27247H12.9111C13.5022 8.27247 14 7.70286 14 7.02645V6.97305C14 6.29663 13.5022 5.72702 12.9111 5.72702L8.27234 5.72702L8.27234 1.08889C8.27234 0.482222 7.70273 0 7.02631 0L6.97291 0C6.2965 0 5.72688 0.482222 5.72688 1.08889L5.72688 5.72702L1.08889 5.72702C0.482222 5.72702 0 6.29663 0 6.97305L0 7.02645C0 7.70286 0.482222 8.27247 1.08889 8.27247L5.72688 8.27247Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPIcon);
export default __webpack_public_path__ + "static/media/p-icon.917a3bd7a4ba0b294895cb14a3a39a74.svg";
export { ForwardRef as ReactComponent };